import { ReactNode } from "react";
import { LeftOutlined } from "@ant-design/icons";
import { useQuery } from "@tanstack/react-query";
import { Button, Skeleton, Typography } from "antd";
import { useCoordinator } from "@/shared/lib/hooks";
import { useUnifiedAutoResize } from "@/shared/utils";
import { journalsQueries } from "@entities/journal";
import SettingsCard from "../settings-card";
import { AdministratorSettingsCard } from "../single-table-module/single-table-module";
import "./journals-settings.scss";

type JournalsSettingsProps = {
  goBack: () => void;
};

export const JournalsSettings = ({ goBack }: JournalsSettingsProps) => {
  const { titleId, mainJournalId } = useCoordinator();

  // Автоматический resize при любом изменении DOM в unified режиме
  useUnifiedAutoResize();

  const { data: mainJournal, isLoading: isMainJournalLoading } = useQuery(
    journalsQueries.getJournal({ mainJournalId }),
  );

  const sectionOneId = mainJournal?.mainJournal?.section1?.sectionId;

  const sectionTwoId = mainJournal?.mainJournal?.section2?.sectionId;

  const sectionThreeId = mainJournal?.mainJournal?.section3?.sectionId;

  const sectionFourId = mainJournal?.mainJournal?.section4?.sectionId;

  const sectionSixId = mainJournal?.mainJournal?.section6?.sectionId;

  return (
    <div className="journals-settings">
      <div className="journals-settings__header">
        <Button
          icon={(<LeftOutlined />) as ReactNode}
          onClick={goBack}
          iconPosition="start"
        />
        <Typography.Title style={{ marginBottom: 0 }} level={4}>
          Настройки
        </Typography.Title>
      </div>
      {mainJournalId && (
        <AdministratorSettingsCard mainJournalId={mainJournalId} />
      )}
      <SettingsCard
        section="title"
        id={titleId}
        parts={["inputters", "approvers", "senders"]}
      />
      {isMainJournalLoading ? (
        <Skeleton.Node
          style={{ width: "100%", height: "158px", borderRadius: "16px" }}
          active
        />
      ) : (
        sectionOneId && (
          <SettingsCard
            section="section-one"
            id={sectionOneId}
            parts={["inputters"]}
          />
        )
      )}
      {isMainJournalLoading ? (
        <Skeleton.Node
          style={{ width: "100%", height: "158px", borderRadius: "16px" }}
          active
        />
      ) : (
        sectionTwoId && (
          <SettingsCard
            section="section-two"
            id={sectionTwoId}
            parts={["inputters"]}
          />
        )
      )}
        {isMainJournalLoading ? (
          <Skeleton.Node
            style={{ width: "100%", height: "158px", borderRadius: "16px" }}
            active
          />
        ) : (
          sectionThreeId && (
            <SettingsCard
              section="section-three"
              id={sectionThreeId}
              parts={["inputters"]}
            />
          )
        )}
        {isMainJournalLoading ? (
          <Skeleton.Node
            style={{ width: "100%", height: "158px", borderRadius: "16px" }}
            active
          />
        ) : (
          sectionFourId && (
            <SettingsCard
              section="section-four"
              id={sectionFourId}
              parts={["inputters"]}
            />
          )
        )}
        {isMainJournalLoading ? (
          <Skeleton.Node
            style={{ width: "100%", height: "158px", borderRadius: "16px" }}
            active
          />
        ) : (
          sectionSixId && (
            <SettingsCard
              section="section-six"
              id={sectionSixId}
              parts={["inputters"]}
            />
          )
        )}
    </div>
  );
};
